export default __webpack_public_path__ + "static/media/gallery_11.2d8cb028.jpg";